<template>
  <div class="img-content">
    <div class="right-content">
      <navigation :navName="nav"></navigation>
      <div class="table-container">
        <table-box :data="configDetail"
                   ref="table"
                   :tableHeight="tableHeight"
                   id="rebateSetTable">
          <table-column :prop="item.config.name"
                        :label="item.name"
                        v-for="(item,index) in list"
                        :key="index"> </table-column>
          <table-column label="操作"
                        :width="'100px'"
                        alignType="left">
            <template slot-scope="scope">
              <span class="table-btn"
                    @click="handleEdit(scope.$index, scope.row)">编辑</span>
            </template>
          </table-column>
        </table-box>
        <!-- <pagination @currentChange="handleCurrentChange"
                  @sizeChange="handleSizeChange"
                  :currentPage.sync="searchForm.page"
                  :pageSize.sync="searchForm.per_page"
                  :total="total">
      </pagination> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import navigation from './navigation';

export default {
  data() {
    return {
      msg: {},
      pageSize: 10,
      pageNum: 1,
      tableHeight: 1,
      currentPage: 1,
      nav: '',
    };
  },
  components: {
    navigation,
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight =
        document.documentElement.clientHeight - this.$refs.table.$el.offsetTop - 100;
    });
    this.$store.commit('getconfig', JSON.parse(localStorage.getItem('myConfig')));
  },
  methods: {
    handleEdit() {
      this.$router.push({
        path: 'editSetting',
      });
    },
  },
  computed: {
    ...mapState([
      'configDetail',
    ]),
    list() {
      if (this.$store.state.config.setConfig) {
        return this.$store.state.config.setConfig.filter(item => item.config.display);
      }
      return [];
    },
  },
};
</script>
<style lang="less">
.navigation {
  margin-bottom: 20px;
}
.btn {
  margin-bottom: 10px;
  display: flex;
  .el-input {
    width: 40%;
    margin-right: 20px;
  }
}
.pager {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/websiteConfig/settingTable.vue